export default __webpack_public_path__ + "media/images/amenities/seasonings-26056d41eaaaf1ea736a9a0e14e4e246.jpeg";